import { configs } from '@/configs'

export function getLoginOrRegisterUrl({
  type,
  cnpj,
  email,
  subservice,
  isLogout = false,
}: {
  type: 'login' | 'register'
  email?: string
  cnpj?: string
  subservice?: 'certificados' | 'graduacao-e-pos'
  isLogout?: boolean
}) {
  const bases: Record<typeof type, string> = {
    login: `${configs.SIGN_FRONT_URL}/login`,
    register: `${configs.SIGN_FRONT_URL}/registrar`,
  }
  const base = bases[type]
  const params = {
    service: 'portal-diploma',
    subservice,
    email,
    cnpj,
    logout: isLogout ? 'true' : undefined,
    continue: encodeURIComponent(
      `${configs.FRONT_URL}/login?completeAuth=true${
        subservice ? `&subservice=${subservice}` : ''
      }`,
    ),
  }
  const paramsString = Object.entries(params)
    .filter(([, value]) => Boolean(value))
    .map(([key, value]) => `${key}=${value}`)
    .join('&')

  return `${base}?${paramsString}`
}
